module.exports = __webpack_public_path__ + "static/media/GDocsPortalSiteTnC_ES.14234dcd.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff_PDF/GDocsPortalSiteTnC_ES.pdf
// module id = 687
// module chunks = 4